
import { Building, FileText, Box, Droplets } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PortfolioType } from "@/types/portfolio";

interface EmptyItemsStateProps {
  portfolioType: PortfolioType;
  onAddClick: () => void;
}

export const EmptyItemsState = ({ portfolioType, onAddClick }: EmptyItemsStateProps) => {
  const getItemTypeDetails = (type: PortfolioType) => {
    switch (type) {
      case "buildings":
        return {
          name: "Building",
          icon: <Building className="h-12 w-12 mb-4 text-muted-foreground" />,
          description:
            "Add buildings to your portfolio to track their certification progress.",
        };
      case "formulated_products":
        return {
          name: "Product",
          icon: <Droplets className="h-12 w-12 mb-4 text-muted-foreground" />,
          description:
            "Add formulated products to your portfolio to track their certification progress.",
        };
      case "interior_spaces":
        return {
          name: "Space",
          icon: <Box className="h-12 w-12 mb-4 text-muted-foreground" />,
          description:
            "Add interior spaces to your portfolio to track their certification progress.",
        };
      case "paper_rolls":
        return {
          name: "Paper Roll",
          icon: <FileText className="h-12 w-12 mb-4 text-muted-foreground" />,
          description:
            "Add paper rolls to your portfolio to track their certification progress.",
        };
      default:
        return {
          name: "Item",
          icon: <Box className="h-12 w-12 mb-4 text-muted-foreground" />,
          description: "Add items to your portfolio to track their certification progress.",
        };
    }
  };

  const { name, icon, description } = getItemTypeDetails(portfolioType);

  return (
    <div className="flex flex-col items-center justify-center p-8 text-center bg-muted/50 rounded-lg border border-dashed h-64">
      {icon}
      <h3 className="text-lg font-medium mb-2">No {name}s Added Yet</h3>
      <p className="text-sm text-muted-foreground mb-6 max-w-md">{description}</p>
      <Button onClick={onAddClick}>Add Your First {name}</Button>
    </div>
  );
};
